import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'

import router from '../router';

const survey = {
    state: {
        surveyList: [],
        filteredSurveyList: [],
    },
    mutations: {
        SURVEY_LIST(state, payload) {
            state.surveyList = payload
        },
        FILTERED_SURVEY_LIST(state, payload) {
            state.filteredSurveyList = payload
        }
    },
    actions: {
        /* eslint-disable no-unused-vars */
        getAllSurveys({commit}) {
            return firebase.firestore().collection('surveys').get().then(snapshot => {
                let surveys = []
                snapshot.forEach(doc => surveys.push(doc.data()))
                commit('SURVEY_LIST', surveys)
                commit('FILTERED_SURVEY_LIST', surveys)
            }).catch(() => {
                commit('SURVEY_LIST', [])
                commit('FILTERED_SURVEY_LIST', [])
            })
        },
        filterSurveys({state, commit}, filterArgs) {
            if (filterArgs) {
                let filteredList = state.surveyList

                // Filter for specific plants
                if (filterArgs.plantIds && filterArgs.plantIds.length > 0) {
                    filteredList = state.surveyList.filter(({neophyte}) => filterArgs.plantIds.includes(neophyte))
                }

                // Filter for surveys with a date less or equal than given one
                if (filterArgs.toDate) {
                    filteredList = filteredList.filter(({date}) => date <= filterArgs.toDate)
                }

                // Filter for surveys with matching contractor's email address
                if (filterArgs.contractorRef) {
                    filteredList = filteredList.filter(({contractor}) => contractor === filterArgs.contractorRef)
                }

                if (filterArgs.assignedWorker) {
                    if(filterArgs.assignedWorker === true)
                        filteredList = filteredList.filter(({assignedWorker}) => assignedWorker!==undefined && assignedWorker != null)
                    else if(filterArgs.assignedWorker)
                        filteredList = filteredList.filter(({assignedWorker}) => assignedWorker === filterArgs.assignedWorker && assignedWorker!==undefined)

                }

                if (filterArgs.usersRef) {
                    let resultList = []
                    let users = filterArgs.usersRef;

                    for (let i=0; i < users.length; i++) {
                        resultList.push(...filteredList.filter(({contractor}) => contractor === users[i].email))
                    }
                    filteredList = resultList
                }

                commit('FILTERED_SURVEY_LIST', filteredList)
            } else {
                // No filtering applied -> return all results
                commit('FILTERED_SURVEY_LIST', state.surveyList)
            }
        },
        applySurvey({commit, getters, dispatch}, survey) {
            // Get document reference
            let surveysRef = firebase.firestore().collection('surveys').doc(survey.uuid);

            surveysRef.get().then(doc => {
                // Create or update document
                if (!doc.exists) {
                    let parentSurvey = getters.surveyByuuid(survey.parentid)
                    surveysRef.set(survey).then(
                        ()=>{
                            console.log("updated survey_: " + survey.uuid)
                            if(typeof parentSurvey != 'undefined') {
                                console.log(parentSurvey)
                                parentSurvey.assignedWorker = null
                                dispatch('applySurvey', parentSurvey)
                            }
                        }
                    )
                } else {
                    surveysRef.update(survey)
                }
                router.push({name: 'Surveys'})
            })
        },
        deleteSurvey({state, commit}, surveyId) {
            firebase.firestore().collection('surveys').where('uuid', '==', surveyId).get().then(snapshot => {
                snapshot.forEach(surveyDoc => {
                    firebase.firestore().collection('surveys').doc(surveyDoc.id).delete().then(() => {
                        // Loop through surveys and filter for all others than deleted one
                        let surveys = state.surveyList.filter(survey => {
                            return survey.uuid != surveyId
                        })
                        commit('SURVEY_LIST', surveys)
                        commit('FILTERED_SURVEY_LIST', surveys)
                    })
                })
            })
        }
    },
    getters: {
        surveyList(state) {
            return state.surveyList
        },
        filteredSurveyList(state) {
            return state.filteredSurveyList
        },
        surveyByuuid:state => uuid => {
            return state.surveyList.filter(survey => survey.uuid==uuid)[0]
        }
    }
}

export default survey
